// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__gq8kC","title":"Header_title__j1A9b","subtitle":"Header_subtitle__TS3Aq"};